import { useApi } from '@/api';
import { CardList, Link, LinkButton, ListSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import {
  CurrencyValue,
  Flex,
  ListItem,
  WalletAddress
} from '@blockanalitica/ui';

export default function TopSuppliers({ ...rest }) {
  const [data, error] = useApi({
    url: `/stusds/depositors/`,
    queryParams: {
      p_size: '3',
      order: '-total_balance'
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <CardList
        title="Top Suppliers"
        action={
          <LinkButton to="suppliers" variant="secondary">
            view all
          </LinkButton>
        }
        {...rest}>
        {data['results'].length > 0 &&
          data['results'].map((row) => (
            <ListItem
              variant="link"
              // @ts-ignore
              as={Link}
              key={row.urn}
              to={`suppliers/${row.wallet_address}`}>
              <Flex justifyContent="space-between" alignItems="center">
                <WalletAddress address={row.wallet_address} />
                <CurrencyValue
                  value={row.total_balance}
                  options={{
                    currency: tokensMapping('stUSDS'),
                    iconSize: '0'
                  }}
                />
              </Flex>
            </ListItem>
          ))}
      </CardList>
    );
  }

  return <ListSkeleton {...rest} />;
}
